export default "__VITE_ASSET__tzc3VRIb__"